import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['toggleAll', 'item'];
  static values = { labelTemplate: String };

  toggleAll() {
    this.itemTargets.forEach((checkbox) => {
      checkbox.checked = this.toggleAllTarget.checked;
    });

    this.#renderSubmit();
  }

  updateSelection() {
    this.toggleAllTarget.checked = this.itemTargets.every((checkbox) => checkbox.checked);

    this.#renderSubmit();
  }

  #renderSubmit() {
    const count = this.checkedItems.length;

    this.#submit.querySelector('[data-role="label"]').textContent = this.labelTemplateValue.replace(
      'NUM',
      count > 0 ? count : ''
    );
    this.#submit.disabled = count === 0;
  }

  get checkedItems() {
    return this.itemTargets.filter((checkbox) => checkbox.checked);
  }

  get #submit() {
    return [...this.element.elements].find((element) => element.type === 'submit');
  }
}
